(function() { window.GUID_b6c21daa_c0f5_49e9_8e38_c8e13962ab78 = { getGuid: function() { return "b6c21daa-c0f5-49e9-8e38-c8e13962ab78"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var CamLight;
        (function (CamLight) {
            var ViewModels;
            (function (ViewModels) {
                let RoundEditAction;
                (function (RoundEditAction) {
                    RoundEditAction[RoundEditAction["delete"] = 0] = "delete";
                    RoundEditAction[RoundEditAction["preview"] = 1] = "preview";
                    RoundEditAction[RoundEditAction["next"] = 2] = "next";
                })(RoundEditAction = ViewModels.RoundEditAction || (ViewModels.RoundEditAction = {}));
            })(ViewModels = CamLight.ViewModels || (CamLight.ViewModels = {}));
        })(CamLight = Views.CamLight || (Views.CamLight = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=RoundEditAction.pre.js.map
